import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Studio = () => {
  const { t } = useLanguage();

  return (
    <section id="studio" className="border-t border-white/10 bg-card/40" data-testid="studio-section">
      <div className="mx-auto max-w-[1600px] px-4 py-24 sm:px-8 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-accent sm:text-sm">{t.studio.eyebrow}</p>
              <h2 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-ink sm:text-5xl">
                {t.studio.title}
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-mist sm:text-lg">{t.studio.body}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 overflow-hidden rounded-xl border border-white/10">
                <img
                  src="https://images.unsplash.com/photo-1515703944563-dbcfbf121b3d?crop=entropy&cs=srgb&fm=jpg&q=85"
                  alt="Noste studio"
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover grayscale-[40%] transition-all duration-700 hover:grayscale-0"
                />
              </div>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-7 lg:grid-cols-2 lg:items-end">
            {t.studio.members.map((member, i) => (
              <Reveal key={member.name} delay={i * 0.12} className={i === 1 ? "lg:mb-16" : ""}>
                <div className="group" data-testid={`studio-member-${i}`}>
                  <div className="relative flex aspect-[3/4] items-center justify-center overflow-hidden rounded-xl border border-white/10 bg-elevated transition-colors duration-700 group-hover:border-accent/40">
                    {member.image ? (
                      <img
                        src={member.image}
                        alt={member.name}
                        loading="lazy"
                        className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-[1.03] group-hover:grayscale-0"
                      />
                    ) : (
                      <>
                        <span className="font-display text-[9rem] font-extrabold leading-none text-outline-accent transition-all duration-700 group-hover:scale-105 sm:text-[11rem]">
                          {member.name.charAt(0)}
                        </span>
                        <span className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
                          Noste — {member.name.split(" ")[0]}
                        </span>
                      </>
                    )}
                  </div>
                  <h3 className="mt-4 font-display text-lg font-extrabold uppercase tracking-tight text-ink">{member.name}</h3>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-dim">{member.role}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
